// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__8JkXg","header":"MergedInvoice_header__3ZMRq"};